import { EmployeeDto } from '../dtos/employee.dto';
import { EmployeeModel } from '../models/employee.model';
import { UpdateEmployeeDto } from '../dtos/update-employee.dto';

export class EmployeeMapper {
  static toDto(employeeModel: EmployeeModel): UpdateEmployeeDto {
    return {
      employeeId: employeeModel.employeeId ?? 0,
      categoryIds: employeeModel.categoryIds || undefined,
      bookingConstraints: employeeModel.bookingConstraints || undefined,
      canBook: employeeModel.canBook ?? false,
      externalId: employeeModel.externalId || 0,
      firstName: employeeModel.firstName ?? '',
      lastName: employeeModel.lastName ?? ''
    };
  }

  static toModel(employeeDto: EmployeeDto): EmployeeModel {
    return {
      ...employeeDto,
      categoryIds: employeeDto.categoryIds ?? [],
      bookingConstraints: employeeDto.bookingConstraints ?? []
    };
  }
}
